import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import SimpleReply from './SimpleReply';
import Reply from './Reply';

const RepliesList = props => {
    const renderReply = comment =>
        (<SimpleReply
            key={comment.id.toString()}
            comment={comment}
        />);

    const listOfReplies = [...props.replies];
    const lastComment = listOfReplies.pop();

    return (<div className='replies-list'>
        { listOfReplies && listOfReplies.map(renderReply) }

        <Reply
            parent={props.comment}
            comment={lastComment}
            expandedComponent={props.expandedComponent}
            commentsStore={props.commentsStore}
        />
    </div>);
};

export default observer(RepliesList);

RepliesList.propTypes = {
    comment: PropTypes.object,
    expandedComponent: PropTypes.object,
    replies: PropTypes.array,
    commentsStore: PropTypes.object.isRequired
};
